@if(!!inputControl){
<input
    type="text"
    [name]="randomName"
    [attr.data-testid]="id()"
    class="w-full h-full inline-block border rounded font-sans text-base font-light tracking-wide text-dat-grey-500"
    [id]="id()"
    [attr.data-uiType]="'textBox'"
    [attr.data-styleTarget]="id() + '-input'"
    [placeholder]="placeholder()"
    [formControl]="inputControl"
    [attr.data-styleDisabled]="disabled()"
    mask="separator.0"
    [thousandSeparator]="','"
    separatorLimit="9999"
/>

@if(errorMessage()?.length > 0){
<div
    [attr.data-styleTarget]="id() + '-error'"
    [attr.data-testId]="id() + '-error'"
    [attr.data-uiType]="'error'"
>
    <span class="text-sm text-dat-red-500">{{ errorMessage() }}</span>
</div>
} }
